import { getIn, useFormikContext } from 'formik'
import ClickOutSide from 'hooks/click-outside'
import Paint from 'icons/paint'
import React, { useState } from 'react'
import { HexColorPicker } from 'react-colorful'

function ColorPicker({ name, label, className }) {
  const [openColorPicker, setOpenColorPicker] = useState(false)
  const formik = useFormikContext()
  const field = formik.getFieldProps(name)
  const value = getIn(formik.values, name) || ''
  return (
    <ClickOutSide onClickOutside={() => setOpenColorPicker(false)}>
      <div className={`tw-grow tw-flex tw-flex-col tw-gap-[7px] ${className}`}>
        <div className='tw-text-[#4A403A] tw-text-[15px] md:tw-text-[13px] tw-font-[500] tw-heading-[20px]'>
          {label}
        </div>
        <div
          onClick={() => setOpenColorPicker(!openColorPicker)}
          className='tw-bg-[#F2ECE7] tw-rounded-[5px] tw-min-h-[55px] md:tw-min-h-[40px] tw-px-[11px] tw-flex tw-items-center'
        >
          <div className='tw-grow tw-h-full tw-flex tw-items-center'>
            <div className=' tw-text-[16px] tw-placeholder-gray-300 md:tw-text-[14px] tw-w-full tw-rounded-regular tw-leading-regular tw-flex tw-items-center tw-justify-between tw-h-full'>
              <div className='tw-flex tw-items-center'>
                <span
                  className='tw-w-[18px] tw-h-[18px]  tw-mr-[8px] tw-flex tw-my-auto tw-rounded-sm'
                  style={{
                    background: value || '#000000',
                  }}
                ></span>
                {value || 'No color selected'}
              </div>
              <Paint />
            </div>
          </div>
        </div>
      </div>
      {openColorPicker && (
        <div className='tw-absolute tw-mt-1 tw-z-20'>
          <div className='tw-bg-white tw-border tw-w-min tw-border-slate-300 tw-drop-shadow-lg tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-rounded-md'>
            <HexColorPicker
              color={value || '#000000'}
              onChange={(color) => formik.setFieldValue(name, color)}
              className='tw-mb-3'
            />
            <div className='tw-border tw-border-slate-300 tw-flex tw-items-stretch tw-rounded-md'>
              <div className='tw-bg-slate-100 tw-flex tw-items-center tw-px-3 tw-rounded-l-md tw-text-slate-500'>
                #
              </div>
              <input
                className='tw-border-l tw-border-slate-300 block tw-rounded-r-md tw-placeholder-gray-300 tw-p-1 tw-text-center tw-w-24'
                spellCheck='false'
                {...field}
              />
            </div>
          </div>
        </div>
      )}
    </ClickOutSide>
  )
}

export default ColorPicker
